/* Row videos in the multirow section.
 *
 * The <video> ships with no src at all, so page load fetches nothing. When the
 * row reaches the viewport the script picks the smallest mp4 rendition that
 * still covers the rendered box, attaches it, and - when the block asks for
 * autoplay - plays it muted and looping, i.e. like a GIF. Scrolling away pauses
 * it again so an off-screen clip stops burning battery.
 */
(function () {
  var SELECTOR = 'video[data-pt-row-video]';

  function pickSource(video) {
    var list;
    try {
      list = JSON.parse(video.getAttribute('data-pt-sources') || '[]');
    } catch (e) {
      return '';
    }
    if (!list.length) return '';
    list.sort(function (a, b) {
      return a.w - b.w;
    });
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var needed = (video.clientWidth || video.offsetWidth || 0) * dpr;
    for (var i = 0; i < list.length; i++) {
      if (list[i].w >= needed) return list[i].url;
    }
    return list[list.length - 1].url;
  }

  function activate(video) {
    if (video.getAttribute('data-pt-loaded') !== '1') {
      var url = pickSource(video);
      if (!url) return;
      video.setAttribute('data-pt-loaded', '1');
      video.setAttribute('src', url);
      video.load();
    }
    if (video.getAttribute('data-pt-autoplay') !== 'true') return;
    var played = video.play();
    if (played && typeof played.catch === 'function') {
      played.catch(function () {});
    }
  }

  function start(root) {
    var videos = (root || document).querySelectorAll(SELECTOR);
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(videos, activate);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            activate(video);
          } else if (video.getAttribute('data-pt-autoplay') === 'true' && !video.paused) {
            video.pause();
          }
        });
      },
      { rootMargin: '200px 0px' }
    );

    Array.prototype.forEach.call(videos, function (video) {
      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      start();
    });
  } else {
    start();
  }

  // The theme editor swaps a section's markup without reloading the page.
  document.addEventListener('shopify:section:load', function (event) {
    start(event.target);
  });
})();
